import React from 'react'
import { motion } from 'framer-motion';
import { container, item } from '../../Constant';
import { Link } from 'react-router-dom';

interface PathProps {
    paths?: { name: string, path?: string }[];
}

const Path: React.FC<PathProps> = ({ paths }) => {
    return (
        <div className='border-b border-[rgba(201,201,207,1)] pb-2 pt-10 md:pt-16'>
            <motion.div variants={container} initial="hidden" animate="show" >
                <motion.div variants={item} initial="hidden" animate="show"
                    className='container mx-auto flex items-center justify-start space-x-2 mt-2 mb-4 text-[14px]'
                >
                    {paths && paths.length > 0 &&
                        paths.map((path, index) => (
                            <div key={index} className='flex items-center space-x-2'>
                                {index === paths.length - 1 ?
                                    <p className='font-medium text-[#000]'>{path.name}</p>
                                    :
                                    <Link
                                        to={path.path ? path.path : '/'}
                                        className='font-medium text-[#525252] hover:text-[#000]'
                                    >
                                        {path.name}
                                    </Link>
                                }
                                {index !== paths.length - 1 &&
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-4 w-4"
                                        viewBox="0 0 7 13"
                                        fill="none"
                                        stroke="currentColor"
                                    >
                                        <line opacity="0.5" x1="6.4453" y1="0.852389" x2="0.445304" y2="12.6024" />
                                    </svg>
                                }
                            </div>
                        ))
                    }
                </motion.div>
            </motion.div>
        </div>
    )
}

export default Path;
